import { Tokens } from "@Utilities/enum";
import { onMounted, reactive } from 'vue'
import { useStore } from "vuex";
import useSections from "@Functions/useSections.js";
import { useRoute } from 'vue-router'

export default function useNavigation () {

    const store = useStore();
    const { path } = useRoute();
    const {
        showModal,
        userMetricLevel
    } = useSections();

    const defaultNav = {
        current: "Therapeutic Class",
        type: "",
        item: {},
        selectedLetter: ""
    };

    if (userMetricLevel === 1)
        defaultNav.current = 'Brands'

    const menuNav = reactive(defaultNav)

    onMounted(async () => {
        const cookiesMenuNav = await store.dispatch(
            "Cookies/onGetCookies",
            Tokens.MenuNav
        )
        if (path === '/report/dashboard') {
            await store.dispatch(
                "Cookies/onDeleteCookies",
                Tokens.MenuNav
            )
            menuNav.current = 'Therapeutic Class'
            if (userMetricLevel === 1)
                menuNav.current = 'Brands'
        } else {
            if ( Object.keys(cookiesMenuNav).length > 0 ) {
                menuNav.current = cookiesMenuNav.current
                menuNav.type = cookiesMenuNav.type
                menuNav.item = cookiesMenuNav.item
                if ( 'selectedLetter' in cookiesMenuNav ) {
                    menuNav.selectedLetter = cookiesMenuNav.selectedLetter
                }
            }
        }

    })

    const menuNavRedirect = async (item, params) => {
        let slug = item.name;
        let uri = ""

        showModal.value = false;

        if (params.type === 'Therapeutic Class') {
            // onSectionClicked(item, params.level)
            // onSetSections(params.level)
            return;
        }

        if (params.type === 'Indications') {
            menuNav.item = item;
            menuNav.type = params.type
            menuNav.selectedLetter = params.selectedLetter
            uri = `/report/demographic/indication-groups/indication`;
        }

        if (params.type === 'Specialties') {
            menuNav.item = item;
            menuNav.type = params.type
            uri = `/report/demographic/specialty-groups/specialty`;
        }

        if (params.type === 'Brands') {
            menuNav.item = item;
            menuNav.type = params.type
            menuNav.selectedLetter = params.selectedLetter
            slug = item.slug;
            uri = `/report/drug-info/form/brand`;
        }

        if (params.type === 'Generics') {
            menuNav.item = item;
            menuNav.type = params.type
            menuNav.selectedLetter = params.selectedLetter
            slug = item.slug;
            uri = `/report/drug-info/form/generic`;
        }

        if (slug) {
            uri = uri + `?slug=${slug}`;
        }

        if (slug && params.sort) {
            uri += `&sort=${params.sort}`
        }
        store.dispatch('Cookies/onSetCookies', { key: Tokens.MenuNav, value: menuNav })

        window.location.href = uri;
    };

    const onMenuNavTypeChange = (item) => {
        if (item === 'Reports') {
            window.location = '/template/report/list/'
        }
        menuNav.current = item
    }

    return {
        menuNavRedirect,
        menuNav,
        onMenuNavTypeChange
    }

}
